import {
  Box,
  Button,
  Container,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react'
import { Hero, Layout } from '@common'
import { ISSRPageData } from '@interfaces'
import { Link } from '@ui'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const SupportScreen = ({ global: { navigation } }: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  return (
    <Layout
      title={t('explore-ssm:support.pageTitle')}
      navigation={navigation}
      path={asPath}
    >
      <Hero
        bgImageUrl="https://drupal.sakipsabancimuzesi.org/sites/default/files/styles/webp/public/2024-12/atlikosk_banner_1.jpg.webp"
        subTitle={t('explore-ssm:support.banner.subTitle')}
        title={t('explore-ssm:support.banner.title')}
      />

      <Box
        as="section"
        pb={{ base: 'padding.primary2', lg: 'padding.primary4' }}
        mt={{ base: 'padding.primary', lg: 'padding.primary2' }}
      >

        <Container mb={{ base: 'padding.primary', lg: 'padding.primary2' }}>
          <Text fontSize={{ base: '2xl', lg: '3xl' }} color="red.primary">
            {t('explore-ssm:support.how.title')}
          </Text>
        </Container>

        <Box
          maxWidth="container.secondary"
          mx="auto"
          px={{ base: 'padding.primary', lg: '0' }}
        >
          <Text fontWeight="light" pb={4}>
            {t('explore-ssm:support.how.description')}
          </Text>

          <Text as="h4" fontWeight="bold" pb={4}>
            {t('explore-ssm:support.how.ourSupporters')}
          </Text>
          <UnorderedList>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Sabancı Holding
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Akbank
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Sabancı Vakfı
            </ListItem>
          </UnorderedList>
          <br/>
          <Text as="h4" fontWeight="bold" pb={4}>
            Program ve Etkinlik Sponsorları
          </Text>
          <UnorderedList>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              &quot;Müzede Sahne&quot; ve &quot;Müzede Suare&quot; Sponsoru: Sabancı Vakfı
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              &quot;Müzede Suare: American Express ile Bir Yaz Gecesi&quot; Sponsoru: American Express
            </ListItem>
          </UnorderedList>
          <br/>
          <Text as="h4" fontWeight="bold" pb={4}>
            Özel Projeler
          </Text>
          <UnorderedList>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Renk Sponsoru: Jotun
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Müze Mobilya Sponsoru: Norde
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Acil Sağlık Hizmetleri Sponsoru: Medline
            </ListItem>
          </UnorderedList>

          <br/>
          <Text as="h4" fontWeight="bold" pb={4}>
            SSM Öğrenme Programları Sponsorları
          </Text>
          <UnorderedList>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Mekânsal Dönüşüm Sponsoru: Kale
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Mobilya Sponsoru: Norde
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Mobilya Sponsoru: Racuun Kids
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Mobilya Sponsoru: Regout
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Mobilya Sponsoru: IKEA
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Yapı Malzemeleri Sponsoru: Kastamonu Entegre
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Elektrik Donanımı Sponsoru: Jung Türkiye
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Ürün Sponsoru: Faber-Castell
            </ListItem>
            <ListItem fontWeight="light" fontSize="sm" mb={1}>
              Temizlik Ürünleri Sponsoru: Lindos
            </ListItem>
          </UnorderedList>

          <br/>

          <Text as="h4" fontWeight="bold" pb={4}>
            {t('explore-ssm:support.how.loyaltyPrograms')}
          </Text>

          <Text fontWeight="light" pb={4}>
            {t('explore-ssm:support.how.loyaltyProgramsDescription')}
          </Text>

          <Box
            flex={{ base: 'auto', lg: '1' }}
            mt={{ base: 'padding.primary', lg: '0' }}
            pl={{ base: '0', lg: 0 }}
          >

          </Box>
          <Button
            width="180px"
            height="60px"
            as={Link}
            target="_blank"
            href="https://www.sakipsabancimuzesi.org/uyelik"
            mt={8}
            mb={8}
          >
            {t('common:moreInformationButtonLabel')}
          </Button>

          <Text as="h4" fontWeight="bold" pb={4}>
            {t('explore-ssm:support.how.ssmShop.title')}
          </Text>

          <Text fontWeight="light" pb={4}>
            {t('explore-ssm:support.how.ssmShop.description')}
          </Text>
          <Button
            as={Link}
            target="_blank"
            href="https://sakipsabancimuzesi.org/shop/"
            mt={4}
            width="180px"
            height="60px"
            mb={4}
          >
            {t('common:viewProductsButtonLabel')}
          </Button>
        </Box>
      </Box>
      <Box
        as="section"
        pb={{ base: 'padding.primary2', lg: 'padding.primary4' }}
      >
        <Container mb={{ base: 'padding.primary', lg: 'padding.primary2' }}>
          <Text fontSize={{ base: '2xl', lg: '3xl' }} color="red.primary">
            {t('explore-ssm:support.information.title')}
          </Text>
        </Container>
        <Box
          maxWidth="container.secondary"
          mx="auto"
          px={{ base: 'padding.primary', lg: '0' }}
        >
          <Text fontWeight="light" pb={4}>
            {t('explore-ssm:support.information.description')}
            <br />
          </Text>
          <Text>
            <strong>{t('common:contact.email')}:</strong>&nbsp;
            <Link href="mailto:destek.ssm@sabanciuniv.edu" variant="inlineLink">
              destek.ssm@sabanciuniv.edu
            </Link>
            <br />
            <strong>{t('common:contact.tel')}:</strong>&nbsp;&nbsp;
            <Link href="tel:0 212 277 22 00" variant="inlineLink">
              0 212 277 22 00
            </Link>
          </Text>
        </Box>
      </Box>
    </Layout>
  )
}

export default SupportScreen
